import { render, staticRenderFns } from "./PaginationItemsPerPageDropdown.vue?vue&type=template&id=3a7a745f"
import script from "./PaginationItemsPerPageDropdown.vue?vue&type=script&lang=js"
export * from "./PaginationItemsPerPageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports